window.slate = window.slate || {};
window.theme = window.theme || {};

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();


slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.singleUpsellOptionSelector = options.singleUpsellOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.originalUpsellSelectorId = options.originalUpsellSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.productUpsellJson = options.productUpsellJson;
    this.productForm = $(options.productFormSelector, this.$container);
    
    var params = {
      $container: this.$container,
      product: options.product,
      singleOptionSelector: options.singleOptionSelector,
      originalSelectorId: options.originalSelectorId,
      currentVariant: this.currentVariant,
      productForm: this.productForm
    };
    
    this.swatches = new slate.Swatches(params);

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    $(this.singleUpsellOptionSelector, this.$container).on('change', this._onUpsellSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },
    
    
    _getUpsellCurrentOptions: function(target) {
      var currentOptions = $.map($(this.singleUpsellOptionSelector, $(target).closest('form')), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },
    
    
    _getUpsellVariantFromOptions: function(target) {
      var selectedValues = this._getUpsellCurrentOptions(target);
      var product = JSON.parse($(this.productUpsellJson, $(target).closest('form')).html());
      var variants = product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    
    _onUpsellSelectChange: function(e) {
      var variant = this._getUpsellVariantFromOptions(e.target);

      this.$container.trigger({
        type: 'upsellVariantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateUpsellMasterSelect(variant, e.target);
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
    
    _updateUpsellMasterSelect: function(variant, target) {
      $(this.originalUpsellSelectorId, $(target).closest('form'))[0].value = variant.id;
    }
  });

  return Variants;
})();


/**
 * Swatches Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the swatches inputs in any `cart/add` forms that may
 * exist.
 *
 * @namespace swatches
 */

slate.Swatches = (function() {

  var selectors = {
    swatches: '[data-swatch]',
    swatchOptions: '[data-swatch-option]',
  };

  /**
   * Swatches constructor
   *
   * @param {object} options - Settings from `variants.js`
   */
  function Swatches(params) {
    this.$container = params.$container;
    this.product = params.product;
    this.productForm = params.productForm;
    this.currentVariant = params.currentVariant;
    this.singleOptionSelector = params.singleOptionSelector;
    this.singleUpsellOptionSelector = params.singleUpsellOptionSelector;
    this.originalSelectorId = params.originalSelectorId;
    this.variants = this.product.variants;
    this.options = this.product.options;
    this.swatches = $(selectors.swatches, this.productForm);
    this.swatchOptions = this.swatches.find(selectors.swatchOptions);
    this.colorOptionIndex = this.getOptionIndex('color');

    this.hideSwatchesSelects();
    this.defineAvailableColors();

    let self = this;
    if (this.colorOptionIndex >= 0) {
      let $filterableSwatches = this.swatches.filter(function(index) {
        return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
      });
      this.showAvailableOptions(this, $filterableSwatches, this.currentVariant.options[this.colorOptionIndex]);
    } else {
      this.showAvailableOptions(this, this.swatches);
    }

    $(this.swatchOptions, this.$container).filter('input').on('change', function(){
      let evt = $(this);
      self.switchSwatches.bind(self)(evt);
    });

    $(this.swatchOptions, this.$container).filter('option').parent().on('change', function(){
      let evt = $(this);
      self.switchSwatches.bind(self)(evt);
    });
    

    /*$(this.swatchOptions, this.$container).parent().hover(function() {
      let $option = $(this).find(selectors.swatchOptions);

      if ($option.data('swatch-option') == self.colorOptionIndex) {
        let $swatchHolder = $option.closest(selectors.swatches);
        $swatchHolder.find('.header > span').text($swatchHolder.data('swatch')+': '+$option.val());
      }
    }, function() {
      let $option = $(this).find(selectors.swatchOptions);

      if ($option.data('swatch-option') == self.colorOptionIndex) {
        let $swatchHolder = $option.closest(selectors.swatches);
        $swatchHolder.find('.header > span').text($swatchHolder.data('swatch')+': '+self.currentVariant.options[self.colorOptionIndex]);
      }
    });*/
  }

  Swatches.prototype = $.extend({}, Swatches.prototype, {

    hideSwatchesSelects: function() {
      let self = this;

      this.swatches.each(function() {
        let $swatch = $(this);

        $(self.singleOptionSelector).eq(self.getOptionIndex($swatch.data('swatch'))).parent().hide();
      });
    },

    /**
     * Show only a.v.
     *
     * @param {object} variant - Currently selected variant
     */
    defineAvailableColors: function() {
      let self = this;

      if (this.colorOptionIndex >= 0) {
        $.each(this.variants, function(i, variant) {
          if (variant.available) {
            let idToMatch = new RegExp('product-\\d*-swatch-'+self.colorOptionIndex+'-'+variant.options[self.colorOptionIndex].toLowerCase(), "g");
            let $option = self.swatchOptions.filter(function() {
    			return this.id.match(idToMatch);
            });
            self.makeSwatchOptionAvailable($option);
            if (variant.id == self.currentVariant.id) {
              $option.prop('checked', true);
            }
          }
        });
      }
    },

    makeSwatchOptionAvailable: function($option) {
      if ($option.prop("tagName") == 'OPTION') {
	    $option.prop('disabled', false).addClass('available').removeClass('soldout');
      } else {
        $option.prop('disabled', false).parent().addClass('available').removeClass('soldout');
      }

      return $option;
    },

    makeSwatchOptionUnavailable: function($option) {
      if ($option.prop("tagName") == 'OPTION') {
      	$option.prop('selected', false).prop('disabled', true).addClass('soldout').removeClass('available');
      } else {
        $option.prop('checked', false).prop('disabled', true).parent().addClass('soldout').removeClass('available');
      }

      return $option;
    },

    getOptionIndex: function(optionName) {
      return this.options.map(v => v.toLowerCase()).indexOf(optionName.toLowerCase());
    },
    
    switchPromoImage: function() {
      $('.variant-promo').hide();
	  $('#variant-promo-' + this.currentVariant.id).show();
    },

    switchSwatches: function($inital_option) {
      let $option = $inital_option.prop('tagName') == 'SELECT' ? $inital_option.find('option:selected') : $inital_option;
      let self = this;
      let swatchIndex = $option.data('swatch-option');
      let $optionSelector = $(this.singleOptionSelector).eq(swatchIndex);
      let optionVal = $option.val();

      if ($optionSelector.val() !== optionVal) {
        let $otherSwatches = this.swatches.filter(function(index) {
          return $(self.swatches[index]).data('option-index') != swatchIndex;
        });
        if (swatchIndex != this.colorOptionIndex) {
          let $swatchesWithoutColor = this.swatches.filter(function(index) {
            return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
          });
          $otherSwatches = $otherSwatches.filter(value => !$swatchesWithoutColor.has(value));
        }

        if ($otherSwatches.length > 0) {
          this.showAvailableOptions(self, $otherSwatches, optionVal, 'switch');
        }

        $optionSelector.val(optionVal);
      }

      $(this.singleOptionSelector).first().trigger('change');
      this.currentVariant = self.variants.filter(function(v) {return v.id == $(self.originalSelectorId).val();})[0];
      this.switchPromoImage();
      jcf.refreshAll();
    },

    showAvailableOptions: function(self, $swatches, optionVal = '', type = 'load') {
      self.makeSwatchOptionUnavailable($swatches.find(selectors.swatchOptions));

      let hasChecked = false;

      $.each(self.variants, function(i, variant) {
        if (self.colorOptionIndex >= 0) {
          if (((variant.options[self.colorOptionIndex] == optionVal) || (optionVal.length === 0 && variant.options[0] == self.currentVariant.options[0])) && variant.available) {
            $.each($swatches, function(i, swatch) {
              let $swatch = $(swatch);
              let currentSwatchIndex = $swatch.data('option-index');
              let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
              let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').prop('tagName') == 'OPTION' ? $('[data-value="'+variant.options[currentSwatchIndex]+'"]').first() : $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first();

              self.makeSwatchOptionAvailable($option);

              if (type == 'load') {
                if (self.currentVariant.options[currentSwatchIndex] == variant.options[currentSwatchIndex]) {
                  if ($option.prop("tagName") == 'OPTION') {
	                $option.prop('selected', true);
                  } else {
                    $option.prop('checked', true);
                  }
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
              } else {
                if (!hasChecked) {
                  if ($option.prop("tagName") == 'OPTION') {
	                $option.prop('selected', true);
                  } else {
                    $option.prop('checked', true);
                  }
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
                hasChecked = true;
              }

            });

          }
        } else {
           $.each($swatches, function(i, swatch) {
              let $swatch = $(swatch);
              let currentSwatchIndex = $swatch.data('option-index');
              let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
              let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').prop('tagName') == 'OPTION' ? $('[data-value="'+variant.options[currentSwatchIndex]+'"]').first() : $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first();

              self.makeSwatchOptionAvailable($option);
           });
        }
      });
    },

  });


  return Swatches;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    originalUpsellSelectorId: '[data-product-upsell-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productSlider: '[data-product-slider]',
    productThumbnails: '[data-product-thumbnails]',
    productJson: '[data-product-json]',
    productUpsellJson: '[data-upsell-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    singleUpsellOptionSelector: '[data-single-upsell-option-selector]',
    productFormSelector: '[data-product-form]',
    upsellContainer: '[data-upsell]',
    upsellVariantsJson: '[data-product-loop-variants-json]',
    upsellIdField: '[data-upsell-id]',
    upsellsSlider: '[data-upsell-gallery]',
    upsellsAddToCartButton: '[data-add-upsell-to-cart]'
  };

  var cache = {
    currentColor: null
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    var self = this;
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      singleUpsellOptionSelector: selectors.singleUpsellOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      originalUpsellSelectorId: selectors.originalUpsellSelectorId,
      productUpsellJson: selectors.productUpsellJson,
      product: this.productSingleObject,
      productFormSelector: selectors.productFormSelector,
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.currentVariant 	= this.variants.currentVariant;
    //const currentOptions 	= this.getCurrentVariantOptions(this.currentVariant);
    
    this.$upsell = $(selectors.upsellContainer);
    this.upsellVariants = $(selectors.upsellVariantsJson, this.$upsell).length ? JSON.parse($(selectors.upsellVariantsJson, this.$upsell).html()) : null;
    this.upsellId = $(selectors.upsellIdField, this.$upsell);

    // main product slider
    this.$slider = this.$container.find(selectors.productSlider);
    // thumbnails slider
    this.$thumbnails = this.$container.find(selectors.productThumbnails);
    // upsels slider
    this.$upsellsSlider = this.$container.find(selectors.upsellsSlider);

    if(this.$slider.length){
      let $gallery = this.$slider.find('[data-lightbox-opener]');
      $gallery.on('click', function(e) {
        e.preventDefault();
        //узнаём индекс слайда без учёта клонов
        var totalSlides = +$(this).parents('.slider').slick("getSlick").slideCount,
            dataIndex = +$(this).parents('.slide').data('slick-index'),
            trueIndex;
        switch(true){
          case (dataIndex<0):
            trueIndex = totalSlides+dataIndex; break;
          case (dataIndex>=totalSlides):
            trueIndex = dataIndex%totalSlides; break;
          default: 
            trueIndex = dataIndex;
        }  
        //вызывается элемент галереи, соответствующий индексу слайда
        $.fancybox.open($gallery,{autoFocus : false}, trueIndex);
        return false;
      });
      
      this.$slider.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: selectors.productThumbnails,
        responsive: [{
			breakpoint: 768,
			settings: {
              arrows: false,
              dots: true
			}
		}]
      });
    }

    this.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    $(window).on('resize orientationchange', () => {
        self.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    	self.$slider.slick('resize');
	});

    if(this.$thumbnails.length){
      this.$thumbnails.on('init', function() {
        try {
          self.$thumbnails.slick("slickGoTo", 0, true);
        }
        catch(error) {
          setTimeout(function() {self.$thumbnails.trigger('init');}, 5);
          return;
        }

        self.updateProductSlider.bind(self)();
        self.$thumbnails.addClass('slick-loaded');
        self.$slider.addClass('slick-loaded');
      });
      this.$thumbnails.slick({
        lazyLoad: 'ondemand',
        slidesToShow: this.$thumbnails.hasClass('grid--flex') ? 5 : 2,
        slidesToScroll: 1,
        draggable: true,
        arrows: false,
  		focusOnSelect: true,
        asNavFor: selectors.productSlider,
        vertical: this.$thumbnails.hasClass('grid--flex')
      });
    }

    this.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    	$(window).on('resize orientationchange', () => {
        self.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
  	});

    if (this.$upsellsSlider.length) {
      this.$upsellsSlider.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
      });
    }

    this.$container.on('variantChange' + this.namespace, this.updateProductSlider.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
	if (this.upsellVariants) {
    	this.$container.on('variantChange' + this.namespace, this.updateUpsell.bind(this));
	}
	this.$container.on('variantChange' + this.namespace, this.updateSizeChart.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

	if (this.upsellVariants) {
      this.$upsell.find('[data-swatch-option]').parent().on('change' + this.namespace, function(){
        let evt = $(this);
        self._upsellOptionChange.bind(self)(evt);
      });
    }

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

	$(selectors.addToCart, this.$container).on('click.Upsell', function(e){
      self.addUpsellIfRequired.bind(self)(e);
    });

	this.$container.on('click.Upsells', selectors.upsellsAddToCartButton, function(e) {
		self.onAddUpsellToCart.bind(self)(e);
    });

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },
    
    updateSizeChart: function(evt) {
      let colorIndex = this.variants.swatches.colorOptionIndex;
      let currentColor = evt.variant.options[colorIndex];
      $('[data-size-chart]').addClass('hide');
      $('[data-size-chart="'+currentColor+'"]').removeClass('hide');
    },
    
    /**
     * Updates the DOM with the specified variant for the upsell product
     */
    updateUpsell: function(evt) {
      let colorIndex = this.variants.swatches.colorOptionIndex;
      let currentColor = evt.variant.options[colorIndex];
      let upsellSwatches = $('[data-upsell-swatch]', this.$upsell);
      let self = this;
      
      // update active image according to the color
      if (upsellSwatches.prop('tagName') !== 'SELECT') {
        this.$upsell.find('[data-color]').addClass('hide');
        let activeImage = this.$upsell.find('[data-color="'+currentColor+'"]');
        if (activeImage.length) {
          this.$upsell.removeClass('hide');
          activeImage.removeClass('hide');
        } else {
          this.$upsell.addClass('hide');
        }
      }
      
      // update active other options availability
      var upsellCurrentVariant = this.upsellVariants;
      $.each(evt.variant.options, function(index, option) {
        if (index != colorIndex) {
          upsellCurrentVariant = $.grep(upsellCurrentVariant, function(value, i) {
            return value.options[index] == option && value.options[colorIndex] == currentColor;
          });
        }
      });
      
      if (upsellCurrentVariant.length === 0) {
        upsellCurrentVariant = self.upsellVariants[0];
        $.each(upsellCurrentVariant.options, function(index, option) {
          if (index == colorIndex) {
            return;
          }
          
          let currentSwatch = upsellSwatches.filter(function(i, el) {
            return $(el).data('option-index') == index;
          });
          
          let is_checked = false;
          currentSwatch.find('[data-value]').hide();
          $.each(self.upsellVariants, function(i, variant) {
            if (variant.options[colorIndex] == currentColor) {
              let swatchOption = currentSwatch.find('[data-value="'+variant.options[index]+'"]');
              if (swatchOption.prop('tagName') == 'OPTION') {
                if (variant.available) {
                  swatchOption.show();
                  swatchOption.removeClass('soldout');
                  swatchOption.prop('disabled', false); 
                  if (!is_checked) {
                    is_checked = true;
                    swatchOption.prop('selected', true);
                    self.upsellId.val(variant.id);
                  }
                } else {
                  swatchOption.show();
                  swatchOption.addClass('soldout');
                  swatchOption.prop('disabled', true).prop('selected', false);
                }
              } else {
                if (variant.available) {
                  swatchOption.show();
                  swatchOption.removeClass('soldout');
                  swatchOption.children('input').prop('disabled', false); 
                  if (!is_checked) {
                    is_checked = true;
                    swatchOption.children('input').prop('checked', true);
                    self.upsellId.val(variant.id);
                  }
                } else {
                  swatchOption.show();
                  swatchOption.addClass('soldout');
                  swatchOption.children('input').prop('disabled', true).prop('checked', false);
                }
              }
            }
          });
        });
      } else if(upsellCurrentVariant.length === 1) {
        upsellCurrentVariant = upsellCurrentVariant[0];
        
        $.each(upsellCurrentVariant.options, function(index, option) {
          if (index == colorIndex) {
            return;
          }
          
          let currentSwatch = upsellSwatches.filter(function(i, el) {
            return $(el).data('option-index') == index;
          });
          
          let is_checked = false;
          $.each(self.upsellVariants, function(i, variant) {
            if (variant.options[colorIndex] == currentColor) {
              let swatchOption = currentSwatch.find('[data-value="'+variant.options[index]+'"]');
              if (swatchOption.prop('tagName') == 'OPTION') {
                if (variant.available) {
                  swatchOption.removeClass('soldout');
                  swatchOption.prop('disabled', false); 
                  if (!is_checked) {
                    is_checked = true;
                    swatchOption.prop('selected', true);
                    self.upsellId.val(variant.id);
                  }
                } else {
                  swatchOption.addClass('soldout');
                  swatchOption.prop('disabled', true).prop('selected', false);
                }
              } else {
                if (variant.available) {
                  swatchOption.removeClass('soldout');
                  swatchOption.children('input').prop('disabled', false); 
                  if (!is_checked) {
                    is_checked = true;
                    swatchOption.children('input').prop('checked', true);
                    self.upsellId.val(variant.id);
                  }
                } else {
                  swatchOption.addClass('soldout');
                  swatchOption.children('input').prop('disabled', true).prop('checked', false);
                }
              }
            }
          });
        });
      }
    },
    
    _upsellOptionChange: function($option) {
      let optionIndex = $option.prop('tagName') == 'SELECT' ? $option.data('option-index') : $option.data('swatch-option');
      let colorIndex = this.variants.swatches.colorOptionIndex;
      let currentColor = this.currentVariant.options[colorIndex];
      let self = this;
      var currentVariant = this.upsellVariants.filter(function(v) {
        return v.id == self.upsellId.val();
      })[0];
      
      $.each(this.upsellVariants, function(index, variant) {
        if (variant.options[optionIndex] == $option.val()) {
          let variantAccepted = true;
          let variantFound = false;
          for (var i = 0; i < variant.options.length; i++ ) {
            if (i !== optionIndex && variant.options[i] == currentVariant.options[i]) {
              variantFound = true;
              break;
            }
          }
          if (!variantFound) {
            variantAccepted = false;
          }
          if (variantAccepted) {
          	self.upsellId.val(variant.id);
          }
        }
      });
         
      this.$upsellsSlider.slick('slickUnfilter');
      this.$upsellsSlider.slick('slickFilter', function () {
        return $('[data-size="'+$('[data-upsell-swatch]').val()+'"]', this).length === 1;
      });
    },
      
    addUpsellIfRequired: function(e) {
      var requiredUpsell = this.$container.find('[data-dependent-cart-action]');
      var self = this;
      
      if (requiredUpsell.length) {
        e.preventDefault();
        var $upsellForm = requiredUpsell.find('.product-item__form');
        
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $(selectors.addToCart, this.$container).closest('form').serialize() + '&properties[_goes_with]=' + $upsellForm.find('input[name="id"]').val(),
            dataType: 'json',
            success: function() {
              if (!self.$upsell.hasClass('hide')) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: $upsellForm.serialize() + '&properties[_depends_on]=' + self.currentVariant.id,
                  dataType: 'json',
                  success: function() { 
                    Shopify.getCart(function(cart){
                       Shopify.onCartUpdate(cart);
                    });
                  },
                  error: function(error) {
                    console.log(error.responseJSON.description);
                  }
                });
              } else {
                Shopify.getCart(function(cart){
                  Shopify.onCartUpdate(cart);
                });
              }
            },
            error: function(error) {
              console.log(error.responseJSON.description);
            }
          });
      } else {
        var requiredUpsellOnProductPage = this.$container.find('[data-product-dependent-cart-action]');
        
        if (requiredUpsellOnProductPage.length) {
          e.preventDefault();
          var $upsellItemId = self.upsellId.val();
          var $mainAddToCartForm = $(selectors.addToCart, this.$container).closest('form');
          var qty = $mainAddToCartForm.find('[name="quantity"]');
          
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: $mainAddToCartForm.serialize() + '&properties[_goes_with]=' + $upsellItemId,
              dataType: 'json',
              success: function() {
                if (!self.$upsell.hasClass('hide')) {
                  $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: 'id='+$upsellItemId+'&quantity='+qty+'&properties[_depends_on]=' + self.currentVariant.id,
                    dataType: 'json',
                    success: function() { 
                      Shopify.getCart(function(cart){
                         Shopify.onCartUpdate(cart);
                      });
                    },
                    error: function(error) {
                      console.log(error.responseJSON.description);
                    }
                  });
                } else {
                  Shopify.getCart(function(cart){
                    Shopify.onCartUpdate(cart);
                  });
                }
              },
              error: function(error) {
                console.log(error.responseJSON.description);
              }
            });
        }
      }
    },
    
    onAddUpsellToCart: function(e) {
      e.preventDefault();
      
      let self = this;
      let $btn = $(e.target);
      let id = $btn.data('add-upsell-to-cart');
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: 'id='+id+'&quantity=1',
        dataType: 'json',
        success: function() { 
          Shopify.getCart(function(cart){
            Shopify.onCartUpdate(cart);
          });
        },
        error: function(error) {
          console.log(error.responseJSON.description);
        }
      });
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Updates the DOM with the specified slides
     */
    updateProductSlider: function(evt) {
      let variant = evt !== undefined && evt !== null ? evt.variant : this.currentVariant;
      let colorOptionIndex = this.productSingleObject.options.map(v => v.toLowerCase()).indexOf('color');
      let color = variant.options[colorOptionIndex];
      
      if (color == cache.currentColor) {
        return;
      }
      
      cache.currentColor = color;

      this.$slider.slick('slickUnfilter');
      let slider_has_color = $('[data-color="' + color + '"]', this.$slider);
      this.$slider.slick('slickFilter', function () {
        if (slider_has_color === undefined || slider_has_color.length === 0){
          return true;
        }
        return $('[data-color="' + color + '"]', this).length === 1;
      });
      this.$slider.slick('resize');

      this.$thumbnails.slick('slickUnfilter');
      let thumbnails_has_color = $('[data-color="' + color + '"]', this.$thumbnails);
      this.$thumbnails.slick('slickFilter', function () {
        if (thumbnails_has_color === undefined || thumbnails_has_color.length === 0){
          return true;
        }
        return $('[data-color="' + color + '"]', this).length === 1;
      });
      this.$thumbnails.slick('resize');
      var index = 0;
      $.each(this.$thumbnails.find('.slick-slide').not(".slick-cloned"), function (t, v) {
        $(v).attr("data-slick-index", index);
        index++;
      });
      
      if (this.$upsellsSlider !== undefined && this.$upsellsSlider.length) {
        this.$upsellsSlider.slick('slickUnfilter');
        this.$upsellsSlider.slick('slickFilter', function () {
          return $('[data-size="'+$('[data-upsell-swatch]').val()+'"]', this).length === 1;
        });
      	this.$upsellsSlider.slick('resize');
      }
    },


    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();




function initDrawers() {
  var $body = $('body');
  
  var $opener = $('[data-open]');

  $opener.on('click.Drawer', function(e){
    e.preventDefault();

    var drawerId = $(this).data('open');
  	var $drawer = $('#'+drawerId);
    $body.attr('data-drawer-opened', drawerId);
    $drawer.addClass('opened');
  });

  $body.on('click.Drawer', function(e) {
    var $drawer = $('#'+$('body').attr('data-drawer-opened'));
    if ($drawer.hasClass('opened')) {
      if ($drawer.has(e.target).length == 0 && !$drawer.is(e.target) && $opener.has(e.target).length == 0 && !$opener.is(e.target)){
        $drawer.find('.js-drawer-close').trigger('click');
      }
    }
  });

  $('.js-drawer-close').on('click.Drawer', function(e) {
    e.preventDefault();

    $body.removeAttr('data-drawer-opened');
    $(this).closest('.drawer').removeClass('opened');
  });
}

// open-close init
function initOpenClose() {
	jQuery('.open-close').openClose({
		activeClass: 'active',
		opener: '.opener',
		slider: '.slide',
		animSpeed: 400,
		effect: 'slide'
	});
  
  	jQuery('.collection-sidebar__group').openClose({
		activeClass: 'is-open',
		opener: '.collapsible-trigger',
		slider: '.collapsible-content',
		animSpeed: 400,
		effect: 'slide'
	});
}

// content tabs init
function initTabs() {
  	var tabset = jQuery('.tabset');
	tabset.tabset({
		tabLinks: 'a',
		defaultTab: true,
		autoHeight: false,
      	animSpeed: 10,
        onChange: function(tabs) {
          var activeTab = tabset.next('.tab-content').find('.tab').eq(tabs.activeTabIndex);
          activeTab.find('.products-carousel').slick('resize');
      	}
	});
}

// slick init
function initProductsCarousel() {
  	let $carousel = jQuery('.products-carousel');
	$carousel.slick({
		slidesToScroll: 1,
		slidesToShow: 4,
    infinite:true,
		rows: 0,
      	arrows: true,
		responsive: [{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3
			}
		},{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2
			}
		},{
			breakpoint: 768,
			settings: {
              slidesToShow: $carousel.data('mobile-slides') !== undefined ? $carousel.data('mobile-slides') : 1
			}
		}]
	});
}

function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {

  options = {
    path: '/',
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

function deleteCookie(name) {
  setCookie(name, "", {
    'max-age': -1
  })
}

// initialize custom form elements
function initCustomForms() {
  jcf.setOptions('Select', {
    wrapNative: false,
  });
  jcf.replaceAll();
}

function initFiltersOpener() {
  var filters = $('.filters-wrapper');
  
  $('.filters-opener').on('click', function() {
    filters.toggleClass('opened');
  });
}

function initAnnouncementBarCarousel() {
  $('.announcement-bar__carousel').slick({
    slidesToScroll: 1,
    rows: 0,
    arrows: false,
    autoplay: true
  });
}

function initLoopUpsellAddToCart() {
  $('body').on('click', '.has-required-upsell', function(e) {
    e.preventDefault();
    var $currentForm = $(this).closest('form');
    var $upsellForm = $currentForm.next('.product-item__form');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $currentForm.serialize(),
      dataType: 'json',
      success: function() {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $upsellForm.serialize(),
          dataType: 'json',
          success: function() { 
            Shopify.getCart(function(cart){
              Shopify.onCartUpdate(cart);
            });
          },
          error: function(error) {
            console.log(error.responseJSON.description);
          }
        });
      },
      error: function(error) {
        console.log(error.responseJSON.description);
      }
    });
  });
}

function initMegaDropdowns() {
  let $header = $('#header');
  let $dropdowns = $('.mega-dropdowns .drop');
  let $triggers = $('a[data-drop]');
  let dropdownsShownClass = 'shown';
  let dropdownActiveClass = 'active';
  
  $triggers.on('mouseover', function(e) {
    let $currentItem = $(e.target);
    let dropId = $currentItem.data('drop');
    
    $dropdowns.removeClass(dropdownActiveClass).each(function() {
      let $drop = $(this);
      
      if ($drop.attr('id') == dropId) {
      	$drop.addClass(dropdownActiveClass).closest('.mega-dropdowns').addClass(dropdownsShownClass);
      }
    });
  });
  
  $(document).on('mouseover', function(e) {
    if ($header.find('.logo').is(e.target) || $header.find('.logo').has(e.target).length !== 0 || $header.find('.user-nav').is(e.target) || $header.find('.user-nav').has(e.target).length !== 0) {
      $dropdowns.removeClass(dropdownActiveClass).closest('.mega-dropdowns').removeClass(dropdownsShownClass);
    } else {
      if (!$header.is(e.target) && $header.has(e.target).length === 0) {
        $dropdowns.removeClass(dropdownActiveClass).closest('.mega-dropdowns').removeClass(dropdownsShownClass);
      }
    }
  });
}

function initStickyHeader() {
  let $header = $("#header");
  let headerPostionTop = $('#header').position().top;
  let $body = $('body');
  
  $(window).on('scroll', function() {
    if (window.pageYOffset > headerPostionTop) {
      $header.addClass("sticky");
      $body.css('paddingTop', $header.outerHeight());
    } else {
      $header.removeClass("sticky");
      $body.css('paddingTop', 0);
    }
  });
}

function initResponsiveTables() {
  $('.responsive-table').each(function() {
    let $headerRowColumns = $(this).find('tbody > tr').first().find('td');
    let $excludeFirstRow = $(this).find('tbody > tr:not(:first-child)');

    $excludeFirstRow.each(function() {
      $(this).find('td').each(function(index) {
      	$(this).attr('data-label', $headerRowColumns.eq(index).text());
      });
    });
  });
}


jQuery(function() {  
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  
  initCustomForms();
  initProductsCarousel();
  initAnnouncementBarCarousel();
  initTabs();
  initOpenClose();
  initFiltersOpener();
  initDrawers();
  initLoopUpsellAddToCart();
  initMegaDropdowns();
  initResponsiveTables();
});

jQuery(window).on('load', function() {
  initStickyHeader();
});